import React, { Suspense, useEffect } from "react";
import PropTypes from "prop-types";
import { Paper, Tab, Tabs, AppBar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { updateDrilldownTabNavigation } from "../../redux/measure/measureLandingRedux";
const useStyles = makeStyles((theme) => ({
  tabArea: {
    margin: "5px 0 0",
    "& button": {
      textTransform: "capitalize",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DrillDownTabs = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const appReduxState = useSelector((state) => ({
    ...state.measureLandingDetail,
  }));
  const { drilldownTabNavigation } = appReduxState;
  const { tabItems, variant, data,  outlierChecked,campaignId,testControlChecked } = props;
  // console.log(data,"drilldown");
  const handleChange = (event, newValue) => {
    dispatch(updateDrilldownTabNavigation(newValue));
  };
  return (
    <AppBar position="static" className={classes.tabArea} elevation={0}>
      <Paper square elevation={0}>
        <Tabs
          value={drilldownTabNavigation}
          onChange={handleChange}
          variant={variant}
          indicatorColor="primary"
          textColor="primary"
        >
          {tabItems.map((item) => (
            <Tab
              key={item.id}
              label={<p>{item.title} </p>}
              {...a11yProps(item.id)}
            />
          ))}
        </Tabs>
        <Suspense fallback={"Loading..."}>
          <TabPanel value={drilldownTabNavigation} index={0}>
            <props.Tab1
              data={data}
              campaignId={campaignId}
              outlierChecked={outlierChecked}
              testControlChecked={testControlChecked}
            />
          </TabPanel>
          <TabPanel value={drilldownTabNavigation} index={1}>
            <props.Tab2
              data={data}
              campaignId={campaignId}
              outlierChecked={outlierChecked}
              testControlChecked={testControlChecked}
            />
          </TabPanel>
          <TabPanel value={drilldownTabNavigation} index={2}>
            <props.Tab3
              data={data}
              campaignId={campaignId}
              outlierChecked={outlierChecked}
              testControlChecked={testControlChecked}
            />
          </TabPanel>
        </Suspense>
      </Paper>
    </AppBar>
  );
};

export default DrillDownTabs;
